const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { titleKey: 'routeTitles.home' }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue'),
    meta: { titleKey: 'routeTitles.privacyPolicy' }
  },
  {
    path: '/app',
    name: 'AppDownload',
    component: () => import('@/views/AppDownload.vue'),
    meta: {
      titleKey: 'routeTitles.appDownload',
      defaultLocale: 'ja'
    }
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: () => import('@/views/UserAgreement.vue'),
    meta: { titleKey: 'routeTitles.userAgreement' }
  },
  {
    path: '/paid-service-agreement',
    name: 'PaidServiceAgreement',
    component: () => import('@/views/PaidServiceAgreement.vue'),
    meta: { titleKey: 'routeTitles.paidServiceAgreement' }
  },
  {
    path: '/data-traffic-purchase-agreement',
    name: 'DataTrafficPurchaseAgreement',
    component: () => import('@/views/DataTrafficPurchaseAgreement.vue'),
    meta: { titleKey: 'routeTitles.dataTrafficPurchaseAgreement' }
  },
  {
    path: '/register-help',
    name: 'RegisterHelp',
    component: () => import('@/views/RegisterHelp.vue'),
    meta: { titleKey: 'routeTitles.registerHelp' }
  },
  {
    path: '/device-help-qa',
    name: 'DeviceHelpQA',
    component: () => import('@/views/DeviceHelpQA.vue'),
    meta: { titleKey: 'routeTitles.deviceHelpQa' }
  },
  {
    path: '/digital-life-qa',
    name: 'DigitalLifeQA',
    component: () => import('@/views/DigitalLifeQA.vue'),
    meta: { titleKey: 'routeTitles.digitalLifeQa' }
  },
  {
    path: '/newbie-task',
    name: 'NewbieTask',
    component: () => import('@/views/NewbieTask.vue'),
    meta: { titleKey: 'routeTitles.newbieTask' }
  },
  {
    path: '/daily-task',
    name: 'DailyTask',
    component: () => import('@/views/DailyTask.vue'),
    meta: { titleKey: 'routeTitles.dailyTask' }
  },
  {
    path: '/growth-reward',
    name: 'GrowthReward',
    component: () => import('@/views/GrowthReward.vue'),
    meta: { titleKey: 'routeTitles.growthReward' }
  },
  {
    path: '/personal-info-collection',
    name: 'PersonalInfoCollection',
    component: () => import('@/views/PersonalInfoCollection.vue'),
    meta: { titleKey: 'routeTitles.personalInfoCollection' }
  },
  {
    path: '/third-party-sharing',
    name: 'ThirdPartySharing',
    component: () => import('@/views/ThirdPartySharing.vue'),
    meta: { titleKey: 'routeTitles.thirdPartySharing' }
  },
  {
    path: '/data-deletion',
    name: 'DataDeletion',
    component: () => import('@/views/DataDeletion.vue'),
    meta: { titleKey: 'routeTitles.dataDeletion' }
  },
  {
    path: '/instagram',
    name: 'InstagramRedirect',
    component: () => import('@/views/SocialRedirect.vue'),
    meta: {
      titleKey: 'routeTitles.instagram',
      socialLinks: {
        default: 'https://www.instagram.com/fuzozo_en/',
        en: 'https://www.instagram.com/fuzozo_en/',
        ja: 'https://www.instagram.com/fuzozo_jp/'
      }
    }
  },
  {
    path: '/youtube',
    name: 'YouTubeRedirect',
    component: () => import('@/views/SocialRedirect.vue'),
    meta: {
      titleKey: 'routeTitles.youtube',
      socialLinks: {
        default: 'https://youtube.com/@fuzozo-official',
        en: 'https://youtube.com/@fuzozo-official',
        ja: 'https://youtube.com/@fuzozo-official'
      }
    }
  },
  {
    path: '/tiktok',
    name: 'TikTokRedirect',
    component: () => import('@/views/SocialRedirect.vue'),
    meta: {
      titleKey: 'routeTitles.tiktok',
      socialLinks: {
        default: 'https://www.tiktok.com/@fuzozo_official',
        en: 'https://www.tiktok.com/@fuzozo_official',
        ja: 'https://www.tiktok.com/@fuzozo_official'
      }
    }
  },
  {
    path: '/x',
    name: 'XRedirect',
    component: () => import('@/views/SocialRedirect.vue'),
    meta: {
      titleKey: 'routeTitles.x',
      socialLinks: {
        default: 'https://x.com/FuzozoOfficial',
        en: 'https://x.com/FuzozoOfficial',
        ja: 'https://x.com/fuzozo_jp'
      }
    }
  },
  {
    path: '/line',
    name: 'LineRedirect',
    component: () => import('@/views/SocialRedirect.vue'),
    meta: {
      titleKey: 'routeTitles.line',
      socialLinks: {
        default: 'https://lin.ee/QxyTP8X',
        ja: 'https://lin.ee/QxyTP8X'
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
    meta: { titleKey: 'routeTitles.notFound' }
  }
]

export default routes
